<template>
    <div class="login">
        <header class="login__head">
            <h1 class="adm-title">Accede al panel</h1>
            <p class="adm-muted">Introduce tus credenciales para administrar Selk.</p>
        </header>

        <form class="login__form" @submit.prevent="sendLogin">
            <AdmField
                v-model="credentials.email"
                label="Correo electrónico"
                type="email"
                placeholder="tu@correo.com"
                autocomplete="username"
                required
            />

            <AdmField
                v-model="credentials.password"
                label="Contraseña"
                type="password"
                autocomplete="current-password"
                required
            />

            <!-- El error va en el formulario, donde está la vista del usuario,
                 en lugar del alert() bloqueante que había antes. -->
            <p v-if="error" class="login__error adm-tone-danger" role="alert">
                {{ error }}
            </p>

            <AdmButton type="submit" :loading="loading" block>
                {{ loading ? 'Entrando…' : 'Entrar' }}
            </AdmButton>
        </form>

        <router-link to="/recover/request" class="login__forgot">
            ¿Olvidaste tu contraseña?
        </router-link>
    </div>
</template>

<script>
/**
 * Acceso al panel — migrado en la adenda del 27/09/2026.
 *
 * Antes usaba el sistema visual de la web pública (`.title`, `.button`) dentro
 * del layout público, y confirmaba con tres `alert()`, incluido uno de éxito
 * que obligaba a aceptar un diálogo antes de entrar. Ahora usa las primitivas
 * del panel, el error se muestra en el propio formulario y la ruta va bajo
 * `AuthLayout`.
 */
import { loginUser } from '@/services/authService.js';
import AdmField from '@/components/Admin/ui/AdmField.vue';
import AdmButton from '@/components/Admin/ui/AdmButton.vue';
import { notify } from '@/composables/useAdmToast.js';

export default {
    name: 'loginPage',
    components: { AdmField, AdmButton },
    data() {
        return {
            credentials: { email: '', password: '' },
            loading: false,
            error: '',
        };
    },
    methods: {
        async sendLogin() {
            this.error = '';
            this.loading = true;
            const { user, error } = await loginUser(this.credentials);
            this.loading = false;

            if (!user) {
                // `loginUser` ya normaliza el fallo; el backend responde 401 con
                // el mismo mensaje tanto si el correo no existe como si la clave
                // es incorrecta, para no revelar qué cuentas están registradas.
                this.error = error || 'Correo o contraseña incorrectos.';
                return;
            }

            notify.success(`Bienvenido, ${user.name || user.email || 'de nuevo'}.`);
            this.$router.push('/admin');
        },
    },
};
</script>

<style scoped>
.login {
    display: flex;
    flex-direction: column;
    gap: var(--adm-gap-lg);
}

.login__head { text-align: center; }

.login__head .adm-muted { margin: 0.35rem 0 0 0; }

.login__form {
    display: flex;
    flex-direction: column;
    gap: var(--adm-gap);
}

.login__error {
    margin: 0;
    padding: 0.6rem 0.75rem;
    border-radius: var(--adm-radius-sm);
    font-size: var(--adm-font-sm);
    line-height: 1.4;
}

.login__forgot {
    align-self: center;
    font-family: var(--font-body);
    font-size: var(--adm-font-sm);
    color: var(--color-text);
    text-decoration: none;
    border-bottom: 1px solid transparent;
}

.login__forgot:hover {
    color: var(--color-brand);
    border-bottom-color: var(--color-brand);
}
</style>
